import React, { useState, useEffect } from 'react';
import { Checkbox, Button } from '@ipc/ipc-components';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { setTableActiveFilter, tableLoadData } from '../../../../common/list-table/actions/ListTableActions';
import {
  deleteFlightRequestActionCreator,
  postAddManualFlightRequestActionCreator,
  putEditManualFlightRequestActionCreator,
  getAllIataCodesRequestActionCreator,
  clearPreservedIATA,
  getManualFlightRequestActionCreator,
  clearManualFlightDataActionCreator,
} from '../redux/actions/FlightInformationActions';
import {
  getIsIATALoading, getIATAData, getIsFlightsLoading, getFlightData, getLastRequestStatus, getAllIataCodes, getSelectedIATA, getCheckboxStatus,
} from '../redux/selectors/FlightInformationSelectors';
import ListTable from '../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import { FlightInformationStyles } from '../component/FlightInformation.styles';
import { leftTableColumns, rightTableColumns } from './FlightInformationTableColumns';
import FlightInformationAddEditDialog from '../add-and-edit-manual-flight/component/FlightInformationAddEditDialog';
import ConfirmationDialog from '../../../../common/list-table/helpers/confirmationDialog';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import { formatMessage } from '../../../../../locales/locales';

function FlightInformationContainer(props) {
  const {
    iataData,
    flightData,
    IsFlightsLoading,
    isIATALoading,
    tableLoad,
    addManualFlightRequest,
    deleteRecord,
    userRole,
    lastRequestStatus,
    editRecord,
    gelAllIata,
    allIata,
    preservedIata,
    clearReduxIata,
    getFilterManual,
    getManualFlight,
    clearManualFlight,
    setTableFilter,
  } = props;

  const [showManualEntrySelection, updateShowManualEntrySelection] = useState(false);
  const [flightTableData, updateFlightTableData] = useState(flightData);
  const [selectedIATACode, updateSelectedIATACode] = useState('');
  const [isAddDialogOpen, switchAddDialog] = useState(false);
  const [deleteVisible, updateDeleteVisibility] = useState(false);
  const [selectedFlightToDelete, selectFlightToDelete] = useState(null);
  const [formMode, setFormMode] = useState('ADD');
  const [lastRequestSent, updateLastRequestSent] = useState(null);

  useEffect(() => {
    gelAllIata({ params: { all: 'Y', iataSort: true } });
    if (iataData.length === 0) {
      tableLoad(TableDefinitions.MRD_ADMINISTRATION_IATA.id);
    }
  }, []);

  useEffect(() => {
    if (iataData.length > 0 && selectedIATACode === '') {
      updateSelectedIATACode(preservedIata || iataData[0].iata);
    } else if (selectedIATACode !== '') {
      tableLoad(TableDefinitions.MRD_ADMINISTRATION_FLIGHTS.id, selectedIATACode);
    }
  }, [iataData, selectedIATACode]);

  useEffect(() => {
    if (preservedIata && preservedIata === selectedIATACode) {
      clearReduxIata();
    }
  }, [selectedIATACode]);

  useEffect(() => {
    const filteredFlightData = showManualEntrySelection
      ? flightData.filter((item) => item.manualEntry) : flightData;
    updateFlightTableData(filteredFlightData);
  }, [showManualEntrySelection, flightData]);

  useEffect(() => {
    if (lastRequestStatus && lastRequestSent) {
      switchAddDialog(false);
      updateLastRequestSent(null);
    }
    if (lastRequestStatus !== null && preservedIata) {
      updateSelectedIATACode(preservedIata);
    }
    if (lastRequestStatus !== null && getFilterManual) {
      updateShowManualEntrySelection(getFilterManual);
    }
  }, [lastRequestStatus]);

  const handleDeleteFormOpenedAction = (row) => {
    selectFlightToDelete(row);
    updateDeleteVisibility(true);
  };

  const handleEditFormOpenedAction = (flight) => {
    const { flightId } = flight;

    getManualFlight({ params: { iataCode: selectedIATACode, flightId } });
    setFormMode('EDIT');
    switchAddDialog(true);
  };

  const handleDeleteDialogCancel = () => {
    updateDeleteVisibility(false);
  };

  const handleConfirmDelete = async () => {
    await deleteRecord({
      ...selectedFlightToDelete,
      isFuture: moment(selectedFlightToDelete.validFrom).isAfter(moment()),
      selectedIATACode,
    });
    updateDeleteVisibility(false);
  };

  const handleAddFlightRequest = async (requestParams) => {
    await addManualFlightRequest({
      ...requestParams,
      selectedIATACode,
      showManualEntrySelection,
    });
    updateLastRequestSent('ADD');
  };
  const handleEditFlightRequest = async (requestParams) => {
    await editRecord({
      ...requestParams,
      selectedIATACode,
      showManualEntrySelection,
    });
    updateLastRequestSent('EDIT');
  };

  const handleAddButtonClick = () => {
    setFormMode('ADD');
    switchAddDialog(true);
  };

  const handleAddEditDialogCancel = () => {
    switchAddDialog(false);
    clearManualFlight();
  };

  return (
    <FlightInformationStyles>
      <div className="flight-information-container">
        <div className="flight-table-container">
          <div className="left-table">
            <ListTable
              listId={TableDefinitions.MRD_ADMINISTRATION_IATA.id}
              columns={leftTableColumns(iataData, { selectedIATACode, updateSelectedIATACode })}
              loading={isIATALoading}
              data={iataData}
            />
          </div>
          {iataData.length > 0 && (
            <div className="right-table">
              <div className="flight-button-container">
                {(userRole === 'IPC_ADMIN' || userRole === 'OPER_ADMIN') && (
                  <Button
                    onClick={handleAddButtonClick}
                    className="primary-button-false flight-button"
                  >
                    ADD FLIGHT
                  </Button>
                )}
                <div className="checkbox-filter-container">
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={showManualEntrySelection}
                        onClick={() => {
                          setTableFilter(TableDefinitions.MRD_ADMINISTRATION_FLIGHTS.id, []);
                          updateShowManualEntrySelection(!showManualEntrySelection);
                        }}
                      />
                    )}
                    label="Show Manual Schedule only"
                  />
                </div>
              </div>
              <ListTable
                listId={TableDefinitions.MRD_ADMINISTRATION_FLIGHTS.id}
                columns={rightTableColumns(flightTableData, handleEditFormOpenedAction, handleDeleteFormOpenedAction, userRole)}
                loading={IsFlightsLoading}
                data={flightTableData}
                isDownloadEnable
                downloadFileAs="FLIGHTS_PER_LOCATION"
                downloadFileTemplate="FLIGHTS_PER_LOCATION"
              />
            </div>
          )}
          {
            isAddDialogOpen && (
              <FlightInformationAddEditDialog
                openDialog={isAddDialogOpen}
                closeDialog={handleAddEditDialogCancel}
                formMode={formMode}
                confirmSave={formMode === 'ADD' ? handleAddFlightRequest : handleEditFlightRequest}
                originIataCodes={allIata.map((item) => ({
                  label: item.iata,
                  value: item.iata,
                }))}
                currentDestination={{
                  label: selectedIATACode,
                  value: selectedIATACode,
                }}
              />
            )
          }

        </div>
      </div>
      <ConfirmationDialog
        isOpen={deleteVisible}
        submitButtonText="Yes"
        cancelButtonText="No"
        onClose={handleDeleteDialogCancel}
        onSubmit={handleConfirmDelete}
        confirmationTitle={formatMessage('en',
          selectedFlightToDelete !== null && moment(selectedFlightToDelete.validFrom).isAfter(moment()) ? 'flight.delete.future.label' : 'flight.delete.active.label')}
      />
    </FlightInformationStyles>
  );
}

function mapStateToProps(state) {
  return {
    iataData: getIATAData(state),
    isIATALoading: getIsIATALoading(state),
    flightData: getFlightData(state),
    IsFlightsLoading: getIsFlightsLoading(state),
    userRole: getUserRole(state),
    lastRequestStatus: getLastRequestStatus(state),
    allIata: getAllIataCodes(state),
    preservedIata: getSelectedIATA(state),
    getFilterManual: getCheckboxStatus(state),
  };
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoad: tableLoadData,
  addManualFlightRequest: postAddManualFlightRequestActionCreator,
  deleteRecord: deleteFlightRequestActionCreator,
  editRecord: putEditManualFlightRequestActionCreator,
  gelAllIata: getAllIataCodesRequestActionCreator,
  clearReduxIata: clearPreservedIATA,
  getManualFlight: getManualFlightRequestActionCreator,
  clearManualFlight: clearManualFlightDataActionCreator,
  setTableFilter: setTableActiveFilter,
}, dispatch);

FlightInformationContainer.propTypes = {
  iataData: PropTypes.arrayOf(PropTypes.object),
  allIata: PropTypes.arrayOf(PropTypes.object),
  flightData: PropTypes.arrayOf(PropTypes.object),
  IsFlightsLoading: PropTypes.bool,
  isIATALoading: PropTypes.bool,
  tableLoad: PropTypes.func,
  addManualFlightRequest: PropTypes.func,
  deleteRecord: PropTypes.func,
  editRecord: PropTypes.func,
  userRole: PropTypes.string,
  lastRequestStatus: PropTypes.bool,
  gelAllIata: PropTypes.func,
  preservedIata: PropTypes.string,
  clearReduxIata: PropTypes.func,
  getFilterManual: PropTypes.bool,
  getManualFlight: PropTypes.func,
  clearManualFlight: PropTypes.func,
  setTableFilter: PropTypes.func,
};

FlightInformationContainer.defaultProps = {
  flightData: [],
  IsFlightsLoading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightInformationContainer);
